import { config } from './config';
import { useEffect } from 'react';
import axios from 'axios';
import store from 'store';

// Here you can parse version number if you need it: https://prantlf.github.io/build-number-generator/
const RefreshOnVersionChange = () => {
    const getAppVersion = async () => {
        const url = `${process.env.REACT_APP_BASENAME}/version.txt?c=${Date.now()}`;

        const response = await axios.get(url, {
            headers: {
                'Cache-Control': 'no-cache, no-store, must-revalidate'
            }
        });

        return response.data;
    };

    const refreshApp = async () => {
        const currentUserVersion = store.get(config.user.appVersion);
        const appVersion = await getAppVersion();

        if (appVersion !== currentUserVersion) {
            store.set(config.user.appVersion, appVersion);
            window.location.reload();
        }
    };

    const refreshOnVisible = () => {
        if (document.visibilityState === 'visible') {
            refreshApp();
        }
    };

    useEffect(() => {
        refreshApp();
        window.addEventListener('visibilitychange', refreshOnVisible);

        return () => {
            window.removeEventListener('visibilitychange', refreshOnVisible);
        };
    }, []);

    return null;
};

export default RefreshOnVersionChange;
